import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AboutUsPages } from '../models/aboutUs-pages.model';
import { ToastrService } from 'ngx-toastr';
import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';

@Injectable({
    providedIn: 'root',
})

export class AboutUsService extends BaseService<AboutUsPages> {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    API_URL = `${environment.apiUrl}/BasicPages`;
    API_URLGetAll = `${environment.apiUrl}/BasicPages`;

    constructor(@Inject(HttpClient) http, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http, toastr, translationServices);

    }

}
